import { Path, Svg, G } from '@react-pdf/renderer';

export const NationalityIcon = ({ color }: { color: string }) => {
  return (
    <Svg width="16px" height="16px" viewBox="0 0 488.2 488.2" style={{marginTop: '4px', marginBottom: '4px'}}>
      <G>
        <Path
          fill={color}
          d="M189,131.65h110.3c11.1,0,20.1-9,20.1-20.1v-13.6c0-11.1-9-20.1-20.1-20.1h-6.2v-8.5c0-8.5-6.9-15.4-15.4-15.4h-67.1
          c-8.5,0-15.4,6.9-15.4,15.4v8.5H189c-11.1,0-20.1,9-20.1,20.1v13.6C168.9,122.75,177.9,131.65,189,131.65z"
        />
        <Path
          fill={color}
          d="M432.1,106.55h-94.2v5c0,21.3-17.4,38.7-38.7,38.7H189c-21.3,0-38.7-17.4-38.7-38.7v-5H56.1
          c-31,0-56.1,25.1-56.1,56.1v215.5c0,31,25.1,56.1,56.1,56.1h376c31,0,56.1-25.1,56.1-56.1v-215.5
          C488.2,131.75,463.1,106.55,432.1,106.55z M140.5,367.55c-53.6,0-97.1-43.5-97.1-97.1s43.5-97.1,97.1-97.1
          s97.1,43.5,97.1,97.1S194.2,367.55,140.5,367.55z M433.4,324.95H269.5v-20.9h163.8v20.9H433.4z M433.4,280.85H269.5v-20.9
          h163.8v20.9H433.4z M433.4,236.75H269.5v-20.9h163.8v20.9H433.4z"
        />
        <Path
          fill={color}
          d="M140.8,192.05c-43.3,0-78.4,35.1-78.4,78.4c0,18.6,6.5,35.7,17.3,49.1c0.7-6.3,3.4-13.5,11.4-15.5
          c15.4-3.9,27.9-12.7,27.9-12.7l11.6,36.6l1.6,5l5.2-14.7c-13-18.1,3.4-17.4,3.4-17.4s16.4-0.7,3.4,17.4l5.1,14.6l1.6-4.9v0.1
          l1.8-5.8l9.7-30.8c0,0,12.5,8.8,27.9,12.7c8,2,10.7,9.2,11.4,15.5c10.8-13.4,17.3-30.5,17.3-49.1
          C219.2,227.15,184.1,192.05,140.8,192.05z M171.8,261.25c-2,7.2-4,9.3-5.4,9.4c-1.3,8.6-8.2,19.5-18.9,23.4
          c-4.5,1.6-9.4,1.6-13.9,0c-10.9-3.9-17.6-14.8-18.9-23.4c-1.4-0.1-3.4-2.1-5.4-9.4c-2.8-9.9,0.2-11.4,2.7-11.1
          c-0.5-1.4-0.8-2.7-1.1-4.1c-0.9-4.6-1.1-8.9-0.1-13.1c1.3-5.5,4.3-9.9,7.6-13.4c2.1-2.2,4.5-4.2,7-5.8c2.1-1.4,4.4-2.7,6.8-3.5
          c2-0.7,4-1.1,6.2-1.2c6.8-0.6,11.9,1.1,15.6,3.3c5.5,3,7.6,7.1,7.6,7.1s12.6,0.9,8.4,26.6c-0.2,1.3-0.6,2.7-1.1,4.1
          C171.6,249.95,174.6,251.35,171.8,261.25z"
        />
      </G>
    </Svg>
  );
};
